import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import roreCoefficientsRoutes from 'router/routes/accounts/rore/coefficients';
import roreDisclaimersRoutes from 'router/routes/accounts/rore/disclaimers';
import roreFormatsRoutes from 'router/routes/accounts/rore/formats';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import roreMediaplansRoutes from 'router/routes/accounts/rore/mediaplans';
import rorePagesRoutes from 'router/routes/accounts/rore/pages';
import rorePlacesRoutes from 'router/routes/accounts/rore/places';
import rorePriceTypes from 'router/routes/accounts/rore/pricetypes';
import roreRotationTypes from 'router/routes/accounts/rore/rotationtypes';
import roreSitesRoutes from 'router/routes/accounts/rore/sites';
import roreStrategiesRoutes from 'router/routes/accounts/rore/strategies';
import roreSuppliersRoutes from 'router/routes/accounts/rore/suppliers';
import roreTechCostsRoutes from 'router/routes/accounts/rore/techcosts';
import translation from 'translation';

const accountRoreRoutes = [
  {
    path: 'rore',
    component: NestedRouteComponent,
    meta: {
      components: ['RORE']
    },
    children: [
      ...roreMediaplansRoutes,
      {
        path: 'orders/edit',
        name: 'roreOrdersMassEdit',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Orders')
          }
        },
        component: wrapLegacyRoute('ordersController', 'massEdit')
      },
      {
        path: '',
        component: NestedRouteComponent,
        meta: {
          routeName: {
            segmentName: () => translation.tr('RoRe Reference')
          }
        },
        children: [
          ...roreSuppliersRoutes,
          ...roreSitesRoutes,
          ...rorePlacesRoutes,
          ...rorePagesRoutes,
          ...roreFormatsRoutes,
          ...roreRotationTypes,
          ...roreCoefficientsRoutes,
          ...rorePriceTypes,
          ...roreStrategiesRoutes,
          ...roreDisclaimersRoutes,
          ...roreTechCostsRoutes
        ]
      }
    ]
  }
];

export default accountRoreRoutes;
